export default class DeliveryType {
  static get Self () {
    return 'self'
  }

  static get Delivery () {
    return 'delivery'
  }

  static get Yandex () {
    return 'yandex'
  }

  static get DeliveryClub () {
    return 'deliveryClub'
  }

  static get Aggregator () {
    return 'aggregator'
  }

  static getName (enumValue) {
    switch (enumValue) {
      case DeliveryType.Self:
        return 'Самовывоз'

      case DeliveryType.Delivery:
        return 'Доставка курьером'

      case DeliveryType.Yandex:
        return 'Доставляет Яндекс'

      case DeliveryType.DeliveryClub:
        return 'Доставляет Delivery Club'

      case DeliveryType.Aggregator:
        return 'Доставляет курьер агрегатора'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      DeliveryType.Self,
      DeliveryType.Delivery,
      DeliveryType.Yandex,
      DeliveryType.Aggregator,
    ]

    return variants.map(item => ({
      value: item,
      name: DeliveryType.getName(item),
    }))
  }
}
